import { connect } from 'react-redux';

import { logout } from '../../actions/LogoutPage';
import LogoutPage from './LogoutPage';

const mapsStateToProps = state => ({});

const mapsDispatchToProps = dispatch => ({
	logout() {
		dispatch(logout());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(LogoutPage);
